module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "template template--basic"
  }, [_c('div', {
    staticClass: "login"
  }, [_vm._m(0), _c('div', {
    staticClass: "login__panel-wrap"
  }, [_c('div', {
    staticClass: "login__panel"
  }, [_c('form', {
    attrs: {
      "onsubmit": "return false"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-mail")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email",
      "autofocus": !_vm.isTouch
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _c('primary-button', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "clicked": _vm.submit
    }
  }, [_vm._v("Verstuur")])], 1)]), _c('div', {
    staticClass: "login__auth-other"
  }, [_c('router-link', {
    staticClass: "to-login",
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Terug naar inloggen")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('header', {
    staticClass: "login__header"
  }, [_c('h1', [_vm._v("Wachtwoord vergeten?")]), _c('p', [_vm._v("Geen probleem, wij e-mailen je een link om je wachtwoord te veranderen.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6836e5c4","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/auth/ForgotPassword.vue
// module id = qr67
// module chunks = 1